import { Injectable } from '@angular/core';
import { BaseApiService } from '../../common/base-api.service';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { SettingsProviderService } from '../../common/settings-provider.service';
import { Observable, of } from 'rxjs';
import { IObservationDocumentSummary } from '../../message-models/observation-document-summary.interface';


@Injectable({
  providedIn: 'root'
})
export class ObservationDocumentService extends BaseApiService {
  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'ObservationDocument');
  }

  getAllDocumentSummariesForObservation(companyId: string, observationId?: string, includeExpired?: boolean): Observable<IObservationDocumentSummary[]> {
    return this.post<IObservationDocumentSummary[]>('GetAllDocumentSummariesForObservation', { observationId: observationId, companyId: companyId, includeExpired});
  }

  getObservationDocumentSummary(companyId: string, documentId: string): Observable<IObservationDocumentSummary> {
    return this.post<IObservationDocumentSummary>('GetObservationDocumentSummary', {companyId: companyId, documentId: documentId});
  }

  getObservationDocumentForViewOrDownload(documentId: string): Observable<HttpEvent<Blob>> {
    return this.http.request(new HttpRequest(
      'POST',
      this.baseUrl + 'GetObservationDocumentForViewOrDownload',
      {documentId},
      {
        reportProgress: true,
        responseType: 'blob'
      }));
  }

  createOrUpdateObservationDocument(ObservationDocumentUpload: any): Observable<IObservationDocumentSummary> {
    return this.post<IObservationDocumentSummary>('CreateOrUpdateObservationDocument', ObservationDocumentUpload);
  }

  deleteObservationDocument(documentId: string, companyId: string): Observable<IObservationDocumentSummary> {
    return this.post<IObservationDocumentSummary>('DeleteObservationDocument', {documentId, companyId});
  }
}
